import { appConfig as $config } from '../app.config';
import { App } from './App';
import { UI } from './UI';

export const Router = (function () {
  let routConfig = $config.routing,
    $router,
    $routerPool = [];

  let init = () => {
    $router = new Navigo(routConfig.settings.root, routConfig.settings.useHash, routConfig.settings.hash);
    window['$router'] = $router;

    $router.hooks({
      before: function (done, params) {
        //done();
        // TODO Check unsaved changes not working in REACT
        if (unsavedChanges()) {
          done(false);
        } else {
          done();
        }
      },
      after: function (params) {
        $routerPool.push({
          href: document.location.href,
          rout: $router.lastRouteResolved()
        });
      }
    });

    return $router;
  };

  const unsavedChanges = () => {
    let target = document.location.href;
    let previos = $routerPool[$routerPool.length - 1];
    if (App.pageData($config.GLOBAL.UNSAVED_CHANGES)) {
      history.replaceState(null, document.title, previos.href);
      $router._lastRouteResolved = previos.rout;
      UI.leavePageDialog(null, () => {
        App.pageData($config.GLOBAL.UNSAVED_CHANGES, false);
        $router.navigate(target, true);
      });
      return true;
    }
    return false;
  };

  return {
    init
  };
})();
